module.exports = __webpack_public_path__ + "77e35ba8e5a845b9bfd012dd9324d87f.jpg";